import * as Yup from 'yup';
import { getRequiredMessage } from 'views/declarations/utils/validation-utils';

const COMMODITY_CODE_PATTERN = /^\d{8}$/;
const TARIC_CODE_PATTERN = /^\d{2}$/;

// The form inputs turn an emptied value into null, so the strings are nullable to keep the "required" messages
export const commodityConditionValidationSchema = Yup.object({
    commodityCode: Yup.string()
        .nullable()
        .trim()
        .required(getRequiredMessage('commodityCode'))
        .matches(COMMODITY_CODE_PATTERN, 'Commodity code must be 8 digits.'),
    taricCode: Yup.string()
        .nullable()
        .trim()
        .required(getRequiredMessage('taricCode'))
        .matches(TARIC_CODE_PATTERN, 'TARIC code must be 2 digits.'),
    // Country and condition codes are picked from the AIS codelists, so only the presence of the country is checked.
    // An empty list of condition codes is valid: the mapping then has no conditions.
    countryOrigin: Yup.string().nullable().required('Country of origin is required.'),
    conditionCodes: Yup.array(Yup.string().defined()),
});
